module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f057277"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Blank.vue
// module id = 733
// module chunks = 0